import { useState } from "react";
import { MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import ContractsSelectorComponent from "../../../commons/component/Inputs/ContractSelector/ContractSelectorComponent";

// component functions
import * as ComponentFunctions from './ContractAssociationForm.Functions';
import { Contract } from "../../../models/Entities/Contracts/Contract";

// guide components
import { GuideDrawer, GuideDrawerForm } from "../../../theme/components/GuideDrawer";
import { GuideMessageBar } from "../../../theme/components/GuideMessageBar";

////i18Next
import { useTranslation } from 'react-i18next';

interface FormValidation {
    success: boolean;
    errors: string[];
}



export const ContractAssociationForm = (props: ComponentFunctions.IProps) => {

    const [submittedForm, setSubmittedForm] = useState<boolean>(false);
    const [FormValidationStatus, setFormValidationStatus] = useState<
        FormValidation | undefined
    >();

    const [selectedContract, setSelectedContract] = useState<Contract>();

    //useTranslation()
    const [t] = useTranslation();

    // events
    const HandleCancelForm = () => {
        props.dismissPanel();
    };

    const HandleSaveForm = () => {
        setSubmittedForm(true);
        if (ValidateForm()) {
            props.AssociateContract && selectedContract && props.AssociateContract(selectedContract);
        }
    };

    const SelectedContractActionHadler = (contracts: Contract[]) => {
        setSelectedContract(contracts[0] ? contracts[0] : undefined);
    }


    // form validation
    const ValidateForm = (): boolean => {
        let validationResult: boolean = true;

        let FormValidation: FormValidation = { success: true, errors: [] };
        setFormValidationStatus(FormValidation);

        if (!selectedContract) {
            FormValidation.errors.push(t('contractAssociation.formValidation.selectContract'));
            validationResult = false;
        }

        FormValidation.success = validationResult;
        setFormValidationStatus(FormValidation);
        return validationResult;
    };

    return (
        <GuideDrawer
            open={props.isOpen}
            size="small"
            title={t('contractAssociation.panel.visitInformation')}
            onDismiss={props.dismissPanel}
            testId="contract-association-drawer"
            secondaryAction={{ label: t('contractAssociation.footer.cancelButton'), onClick: HandleCancelForm }}
            primaryAction={{ label: t('contractAssociation.footer.saveButton'), onClick: HandleSaveForm }}
        >
            {submittedForm && !FormValidationStatus?.success && (
                <GuideMessageBar intent="error">
                    <MessageBarBody>
                        <MessageBarTitle>{t('contractAssociation.panel.reviewInformation')}</MessageBarTitle>
                        <ul>
                            {FormValidationStatus?.errors.map(
                                (Error: string, index: number) => (
                                    <li key={index}>{Error}</li>
                                )
                            )}
                        </ul>
                    </MessageBarBody>
                </GuideMessageBar>
            )}
            <GuideDrawerForm onSubmit={HandleSaveForm} testId="contract-association-form">
                <ContractsSelectorComponent ContractsSelected={[]} MultiselectEnable={false} onSelectedContract={(contracts: Contract[]) => SelectedContractActionHadler(contracts)} />
            </GuideDrawerForm>
        </GuideDrawer>
    )
}
